(ns cms.editor.array
  (:require 
    [reagent.core :as r]
    [cms.editor.core :refer [resolve-schema
                             schema-editor
                             populate]]))

(defmethod schema-editor :array [url defs schema node&]
  (let [subschema 
        (resolve-schema defs (get schema "items"))]
    [:table
     (into [:tbody]
           (concat 
             (for [[el i] (map vector @node& (range))]
               [:tr {:key i} 
                [:td (schema-editor 
                       (str url "/" i)
                       defs subschema 
                       (r/cursor node& [i]))]
                [:td 
                 [:button 
                  {:on-click 
                   #(swap! node& 
                           (fn [array]
                             (vec 
                               (concat 
                                 (subvec array 0 i)
                                 (subvec array (inc i))))))}
                  "🗑"]]])
             [[:tr 
               [:td   
                [:button 
                 {:on-click 
                  #(swap! node& (comp vec conj)
                          (populate defs subschema))}
                 "➕"]]]]))]))
